var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M17 8.5C17 3.81212 13.1879 0 8.5 0C3.81212 0 0 3.81212 0 8.5C0 13.1879 3.81212 17 8.5 17H16.9279L15.2588 13.6412C16.387 12.1627 17 10.3597 17 8.5ZM10.1021 14.1976H6.95455V7.72727H10.1021V14.1976ZM10.1021 6.18182H6.95455V3.34848H10.1021V6.18182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatInfo);
export default __webpack_public_path__ + "static/media/chat-info.6072cd0d763c0600705b0c2957ac845a.svg";
export { ForwardRef as ReactComponent };